import { FC, ReactNode } from "react";
import { css } from "@emotion/react";
import { Box } from "@mui/material";
import { BRANCH_FADE_MS, fadeIn } from "./stateTransitionStyles";

export interface BranchFadeProps {
  children: ReactNode;
}

/**
 * 조회 갈래가 바뀔 때 새 갈래만 투명도로 나타나게 한다 — 크기·위치는 처음부터 최종값이다.
 * 호출부가 갈래마다 `key` 를 달리 줘야 다시 마운트되며 페이드가 걸린다.
 */
export const BranchFade: FC<BranchFadeProps> = ({ children }) => (
  <Box css={branchFadeCss}>{children}</Box>
);

const branchFadeCss = css`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  animation: ${fadeIn} ${BRANCH_FADE_MS}ms ease;
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
